import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { getOrgSizeAnalytics } from 'src/services/analytics.service';
import { AppWidgetSummary } from 'src/sections/@dashboard/app';

import GoogleDriveLogo from 'src/assets/storageIcons/googledrive.png';
import DropboxLogo from 'src/assets/storageIcons/dropbox.png';
import OneDriveLogo from 'src/assets/storageIcons/onedrive.png';
import DmonkLogo from 'src/assets/storageIcons/dmonk.png';

const title_icon_map = {
    "dropbox": {
        title: "Dropbox",
        icon: <img src={DropboxLogo} style={{width: '45px', height: 'auto'}} />
    },
    "onedrive": {
        title: "OneDrive",
        icon: <img src={OneDriveLogo} style={{width: '45px', height: 'auto'}} />
    },
    "googledrive": {
        title: "Google Drive",
        icon: <img src={GoogleDriveLogo} style={{width: '45px', height: 'auto'}} />
    },
    "nextcloud": {
        title: "dMonk Drive",
        icon: <img src={DmonkLogo} style={{width: '45px', height: 'auto'}} />
    }
};

class OrgSizeAnalytics extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            by: this.props.by || 'count',
            is_percentage: this.props.is_percentage || false,
            sizeAnalytics: {
                total_size: 0,
                total_count: 0,
                services: []
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.by !== this.props.by || prevProps.is_percentage !== this.props.is_percentage) {
            this.setState({
                by: this.props.by,
                is_percentage: this.props.is_percentage
            });
        }
    }

    async componentDidMount() {

        let size_analytics = await getOrgSizeAnalytics();
        
        if (size_analytics.error) {
            console.error(size_analytics.error);
            return;
        }
        size_analytics = size_analytics.size_analytics;

        size_analytics.services = size_analytics.services.map(service => ({
            ...service,
            size_percentage: size_analytics.total_size > 0 ? ((service.size / size_analytics.total_size) * 100).toFixed(2) : 0,
            count_percentage: size_analytics.total_count > 0 ? ((service.count / size_analytics.total_count) * 100).toFixed(2) : 0
        }));

        this.setState({
            sizeAnalytics: size_analytics
        });

    }

    render() {

        return (
            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <Typography variant="h5" fontWeight={400} color={'gray'}>
                        Where your data is stored
                    </Typography>
                </Grid>

                {(this.state.sizeAnalytics.services.map((service, index) => {

                    if (!service?.service || !title_icon_map[service.service]) {
                        return null;
                    }

                    return (
                        <Grid item xs={12} sm={6} md={3} lg={2} key={index}>
                            <AppWidgetSummary
                                is_percentage={this.state.is_percentage}
                                by={this.state.by}
                                title={title_icon_map[service.service].title}
                                value={this.state.is_percentage ? 
                                    (this.state.by === 'count' ? service.count_percentage : service.size_percentage) :
                                    (this.state.by === 'count' ? service.count : service.size)
                                }
                                icon={title_icon_map[service.service].icon}
                            />
                        </Grid>
                    );
                }))}
            </Grid>
        );
    }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <OrgSizeAnalytics {...props} navigate={navigate} params={params} />;
}
